import { getValue } from './data_storage';

export const translateText = async (text) => {
  const TranslatedText = getValue('TranslatedText');
  const LangCode = getValue('LangCode');
  let Text = text;
  if (LangCode !== 'EN' && Text && TranslatedText) {
    TranslatedText.TranslatedData.map((p) => {
      if (p.ElementValue.trim().toUpperCase() === text.trim().toUpperCase() && LangCode !== 'EN') {
        Text = p.Translatevalue;
        return text;
      }
      else return false;
    });
  }
  return Text;
};
